// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      menu: {
        home: "Home",
        today: "Today",
        bibleReading: "Bible",
        readingPlans: "Reading Plans",
        myMemos: "My Memos",
        sermons: "Sermons",
        versionComparison: "Version Comparison",
        about: "About",
        whoWeAre: "Who We Are",
        exploreBibleMemos: "Explore Bible Memos",
        signIn: "Sign in"
      },
      bookmark: "Bookmarks",
      enter: "Enter",
      quickMenu: {
        memos: "Memo",
        highlights: "Highlight",
        sermon: "Sermon",
        copy:"Copy"
      }
      // Other keys can go here (e.g., button texts, notifications, etc.)
    },
  },
  ko: {
    translation: {
      menu: {
        home: "홈",
        today: "오늘",
        bibleReading: "성경",
        readingPlans: "성경 통독",
        myMemos: "내 메모",
        sermons: "설교",
        versionComparison: "번역비교",
        about: "사이트 소개",
        whoWeAre: "개발자 소개",
        exploreBibleMemos: "사이트 소개",
        signIn: "로그인"
      },
      bookmark:"책갈피",
      enter:"입력",
      quickMenu: {
        memos: "메모",
        highlights: "하이라이트",
        sermon: "설교",
        copy:"복사"
      }
      // Other keys for Korean can be added here
    },
  },
};

const initialLanguage = (() => {
  try {
    const stored = localStorage.getItem('language');
    if (stored === 'ko' || stored === 'en') return stored;
  } catch (_e) {
    // localStorage may be unavailable (privacy mode) — fall through.
  }
  return 'en';
})();

i18n
  .use(initReactI18next) // Connects i18next with React
  .init({
    resources,
    lng: initialLanguage, // Boot from LanguageSwitcher / Settings choice when present
    fallbackLng: 'en',   // Fallback language in case a translation is missing
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
  });

export default i18n;
